import { ArgumentNullError, isNotDefined } from '@hsp/utilities';

import { SignalRNotification } from '@c/notifications/types';

import { BaseHttpService } from 'services/http';

class SignalRService extends BaseHttpService {
  constructor() {
    const uri = process.env.REACT_APP_AZURE_SIGNAL_R;

    if (isNotDefined(uri)) {
      throw new ArgumentNullError('uri', '');
    }

    super({ uri: `${uri}/` });
  }

  addToGroup(user: string, group: string, cancel = false): Promise<unknown> {
    const url = `${group}/add/${user}`;

    return this.post(null, this.defaultRequestConfig(url, cancel));
  }

  removeFromGroup(user: string, group: string, cancel = false): Promise<unknown> {
    const url = `${group}/remove/${user}`;

    return this.post(null, this.defaultRequestConfig(url, cancel));
  }

  sendMessage<TPayload = unknown>(
    payload: SignalRNotification<TPayload>,
    target: string,
    cancel = false
  ): Promise<Record<PropertyKey, unknown>> {
    const url = `send/${target}`;

    return this.post(payload, this.defaultRequestConfig(url, cancel));
  }

  sendMessageToGroup<TPayload = unknown>(
    payload: SignalRNotification<TPayload>,
    group: string,
    target: string,
    cancel = false
  ): Promise<Record<PropertyKey, unknown>> {
    const url = `${group}/send/${target}`;

    return this.post(payload, this.defaultRequestConfig(url, cancel));
  }

  sendMessageToUser<TPayload = unknown>(
    payload: SignalRNotification<TPayload>,
    user: string,
    target: string,
    cancel = false
  ): Promise<Record<PropertyKey, unknown>> {
    const url = `send/${user}/${target}`;

    return this.post(payload, this.defaultRequestConfig(url, cancel));
  }
}

export const signalRService = new SignalRService();
